import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from '../StaticText/connect'
import { URL_AI_CHAT } from '../../services/url/constants'
import { getEmailCustomerServiceUrl } from '../../services/url/index'
import { getPrimary } from '../../services/languages/index'
import Button, { TYPES, SIZES } from '../Button/index'
import ArrowRightIcon from '../Icon/icons/ArrowRight/index'
import { TextLink, TARGET_BLANK } from '../Link/index'

function AlertBarBrowseOnly (props) {
  const { staticText, user } = props
  const userLanguage = getPrimary(user.getIn(['data', 'language']))

  return (
    <div className={`alert-bar-browse-only alert-bar-browse-only--${userLanguage}`}>
      <div className="alert-bar-browse-only__content">
        <div className="alert-bar-browse-only__content-left">
          <p className="alert-bar-browse-only__text">
            <span className="alert-bar-browse-only__title">
              {staticText.getIn(['data', 'browseOnly'])}
            </span>
            <span className="alert-bar-browse-only__description">
              {`${staticText.getIn(['data', 'description'])} `}
            </span>
            <TextLink
              to={getEmailCustomerServiceUrl(userLanguage)}
              target={TARGET_BLANK}
              className="alert-bar-browse-only__contact"
            >
              {staticText.getIn(['data', 'contact'])}
            </TextLink>
          </p>
        </div>
        <div className="alert-bar-browse-only__content-right">
          <Button
            type={TYPES.PRIMARY}
            size={SIZES.XSMALL}
            url={URL_AI_CHAT}
            className="alert-bar-browse-only__cta"
            inverted
          >
            <span className="alert-bar-browse-only__cta-text">
              {staticText.getIn(['data', 'cta'])}
            </span>
            <ArrowRightIcon size={18} />
          </Button>
        </div>
      </div>
    </div>
  )
}

AlertBarBrowseOnly.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'alertBarBrowseOnly' }),
  connectRedux((state) => ({
    user: state.user,
  })),
)(AlertBarBrowseOnly)
